import { Pipe, PipeTransform } from '@angular/core';
import {PlayType} from "../model/playType";
import {playResultGroups} from "../model/playResultGroups";
import {PlayTypeGroups} from "../model/playTypeGroups";

@Pipe({ name: 'filterOptions' })
export class FilterOptionsPipe implements PipeTransform {
  transform(
    enumObj: any,
    row: any,
    context: 'playType' | 'playResult'
  ): string[] {
    if (!enumObj) return [];

    // Liste brute de toutes les valeurs de l'énum
    const values = Object.values(enumObj) as string[];

    if (context === 'playType') {
      const group = row.odk;
      if (group && PlayTypeGroups[group]) {
        return PlayTypeGroups[group];
      }
      return values;
    }

    if (context === 'playResult') {
      if (row.playType && playResultGroups[row.playType as PlayType]) {
        return playResultGroups[row.playType as PlayType];
      }
      return values;
    }

    return values;
  }
}
